var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-full"},[_c('div',{staticClass:"flex flex-row justify-between mb-6 mt-1"},[_c('h1',{staticClass:"text-3xl font-semibold text-gray-900 -mt-1"},[_vm._v(" "+_vm._s(_vm.$t('deliveries.pageTitle'))+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }